const API_BASE_URL = (process.env.REACT_APP_ANINA_AUTH_API_URL || "http://localhost:8000").replace(/\/$/, "");

async function paperRequest(path, options = {}) {
  const method = options.method || "GET";
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: {
      Accept: "application/json",
      ...(method !== "GET" ? { "Content-Type": "application/json", "X-CSRF-Intent": "anina-auth-v1" } : {}),
      ...(options.headers || {}),
    },
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const detailPayload = payload?.detail;
    const detail =
      typeof detailPayload === "string"
        ? detailPayload
        : detailPayload?.message || "Alpaca Paper Trading request failed.";
    const requestError = new Error(detail);
    requestError.status = response.status;
    requestError.providerRequestId =
      payload?.provider_request_id || detailPayload?.provider_request_id || null;
    throw requestError;
  }

  return payload;
}

export function getPaperAccount() {
  return paperRequest("/paper-trading/account");
}

export function getPaperPositions() {
  return paperRequest("/paper-trading/positions");
}

export function getPaperOrders(status = "open", limit = 50) {
  const query = new URLSearchParams({
    status_filter: String(status),
    limit: String(limit),
  });
  return paperRequest(`/paper-trading/orders?${query.toString()}`);
}

export function getPaperOrder(orderId) {
  return paperRequest(`/paper-trading/orders/${encodeURIComponent(orderId)}`);
}

export function submitPaperOrder(order) {
  return paperRequest("/paper-trading/orders", {
    method: "POST",
    body: JSON.stringify(order),
  });
}

export function submitPaperOptionOrder(order) {
  return paperRequest("/paper-trading/options/orders", {
    method: "POST",
    body: JSON.stringify(order),
  });
}

export function cancelPaperOrder(orderId) {
  return paperRequest(`/paper-trading/orders/${encodeURIComponent(orderId)}`, {
    method: "DELETE",
  });
}
